import React from 'react';

export default {
	'Error.Unknown': 'Unknown error',
	'Error.Unknown.Message': 'An error has occurred.',
	'Error.NotFound': 'Not found',
	'Error.NotFound.Message': 'The requested page could not be found.',
	'Error.Forbidden': 'Forbidden',
	'Error.Forbidden.Message': 'You are not allowed to access this page.',
	'Error.Invalid': 'Invalid input',
	'Error.Invalid.Message': 'Invalid fields: {{fields}}.',
	'Error.FileSize.Message': 'The file you tried to upload was too large.',
	'PTMD Portal': 'PTMD Portal',
	'Login': 'Login',
	'Logout': 'Logout',
	'FileDrop.Release': 'Release to select file',
	'FileDrop.Drag': () => <h5>Drag and drop a file here<br/> or </h5>,
	'FileDrop.Select': 'Select a file',
	'GiB': '{{size}} GiB',
	'MiB': '{{size}} MiB',
	'KiB': '{{size}} KiB',
	'bytes': '{{size}} bytes',
	'FileSize.Max': 'The maximum upload size is {{size}}',
	'Modal.Open': 'Open',
	'Modal.Close': 'Close',
	'Language': 'Language'
};
